export const STATE_SIGN_IN = "STATE_SIGN_IN";
export const STATE_SIGN_UP = "STATE_SIGN_UP";
export const STATE_FORGOT_PASSWORD = "STATE_FORGOT_PASSWORD";
